import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import TableNestedDefectSegments from "./TableNestedDefectSegments";
import TableNestedRoadMeasures from "./TableNestedRoadMeasures";

export default function RoadDiagnosticsSegmentComposition() {
    return (
        <>
            <ContentHeader title="Состав участка диагностики" type="simple" />
            <TableNestedRoadMeasures/>
            <TableNestedDefectSegments/>
        </>
    )
}
